import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  output,
} from '@angular/core';
import { UI_MENU_CONTEXT } from './ui-menu-context.token';

@Component({
  selector: 'ui-menu-item',
  standalone: true,
  templateUrl: './ui-menu-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    role: 'menuitem',
    tabindex: '0',
    class:
      'flex items-center gap-2 px-3 py-2 rounded cursor-pointer hover:bg-surface-100 dark:hover:bg-surface-700',
    '[class.opacity-50]': 'disabled()',
    '[class.pointer-events-none]': 'disabled()',
    '[class.hover:bg-red-50]': 'danger()',
    '[class.dark:hover:bg-red-950]': 'danger()',
    '[attr.aria-disabled]': 'disabled()',
    '(click)': 'activate()',
    '(keydown)': 'onKeydown($event)',
  },
})
export class UiMenuItemComponent {
  title = input.required<string>();
  subtitle = input<string | undefined>(undefined);
  icon = input<string | undefined>(undefined);
  danger = input<boolean>(false);
  disabled = input<boolean>(false);
  selected = input<boolean>(false);

  readonly selectItem = output<void>();

  private readonly menuContext = inject(UI_MENU_CONTEXT, { optional: true });

  activate(): void {
    if (this.disabled()) {
      return;
    }
    this.selectItem.emit();
    this.menuContext?.close();
  }

  onKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.activate();
    }
  }
}
